import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';

export const userRouteRedirectGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const router = inject(Router);
  const tab = route.queryParamMap.get('tab');

  // Keep all query params including 'tab'
  const queryParams = { ...route.queryParams };

  // Redirect based on tab parameter, preserving all query params including 'tab'
  if (tab === 'regimen') {
    return router.createUrlTree(['/regimen'], {
      queryParams: queryParams,
      queryParamsHandling: 'merge'
    });
  }

  if (tab === 'explore') {
    return router.createUrlTree(['/explore'], {
      queryParams: queryParams,
      queryParamsHandling: 'merge'
    });
  }

  if (tab === 'shop') {
    return router.createUrlTree(['/shop'], {
      queryParams: queryParams,
      queryParamsHandling: 'merge'
    });
  }

  return true;
};